/**
     * Quote Service - Wrapper around NoCodeBackend API
     * This file maintains compatibility with existing code while using NoCodeBackend
     */

    import * as nocodebackend from './nocodebackend';

    // Re-export all functions from nocodebackend
    export const getQuoteCategories = nocodebackend.getQuoteCategories;
    export const getTopicsByCategory = nocodebackend.getTopicsByCategory;
    export const getAllTopics = nocodebackend.getAllTopics;
    export const getQuotesByTopic = nocodebackend.getQuotesByTopic;
    export const getRandomQuotes = nocodebackend.getRandomQuotes;
    export const createQuote = nocodebackend.createQuote;
    export const updateQuote = nocodebackend.updateQuote;
    export const deleteQuote = nocodebackend.deleteQuote;
    export const createCategory = nocodebackend.createCategory;
    export const createTopic = nocodebackend.createTopic;

    export default {
      getQuoteCategories,
      getTopicsByCategory,
      getAllTopics,
      getQuotesByTopic,
      getRandomQuotes,
      createQuote,
      updateQuote,
      deleteQuote,
      createCategory,
      createTopic,
    };